/* eslint-disable max-lines */
import { CurrencyCode } from '../currencies/constants.ts'

import { CountryIso2Code } from './constants.ts'

import type { ICountry } from './types.ts'

export const COUNTRIES: Record<CountryIso2Code, ICountry> = {
  AD: {
    areaCodes: null,
    currency: CurrencyCode.EUR,
    dialCode: '376',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AD.png',
    iso2: CountryIso2Code.AD,
    name: 'Andorra',
    priority: 0,
    timezone: 'Europe/Andorra',
  },
  AE: {
    areaCodes: null,
    currency: CurrencyCode.AED,
    dialCode: '971',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AE.png',
    iso2: CountryIso2Code.AE,
    name: 'United Arab Emirates (‫الإمارات العربية المتحدة‬‎)',
    priority: 0,
    timezone: 'Asia/Dubai',
  },
  AF: {
    areaCodes: null,
    currency: CurrencyCode.AFN,
    dialCode: '93',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AF.png',
    iso2: CountryIso2Code.AF,
    name: 'Afghanistan (‫افغانستان‬‎)',
    priority: 0,
    timezone: 'Asia/Kabul',
  },
  AG: {
    areaCodes: null,
    currency: CurrencyCode.XCD,
    dialCode: '1268',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AG.png',
    iso2: CountryIso2Code.AG,
    name: 'Antigua and Barbuda',
    priority: 0,
    timezone: 'America/Antigua',
  },
  AI: {
    areaCodes: null,
    currency: CurrencyCode.XCD,
    dialCode: '1264',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AI.png',
    iso2: CountryIso2Code.AI,
    name: 'Anguilla',
    priority: 0,
    timezone: 'America/Anguilla',
  },
  AL: {
    areaCodes: null,
    currency: CurrencyCode.ALL,
    dialCode: '355',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AL.png',
    iso2: CountryIso2Code.AL,
    name: 'Albania (Shqipëri)',
    priority: 0,
    timezone: 'Europe/Tirane',
  },
  AM: {
    areaCodes: null,
    currency: CurrencyCode.AMD,
    dialCode: '374',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AM.png',
    iso2: CountryIso2Code.AM,
    name: 'Armenia (Հայաստան)',
    priority: 0,
    timezone: 'Asia/Yerevan',
  },
  AO: {
    areaCodes: null,
    currency: CurrencyCode.AOA,
    dialCode: '244',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AO.png',
    iso2: CountryIso2Code.AO,
    name: 'Angola',
    priority: 0,
    timezone: 'Africa/Luanda',
  },
  AR: {
    areaCodes: null,
    currency: CurrencyCode.ARS,
    dialCode: '54',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AR.png',
    iso2: CountryIso2Code.AR,
    name: 'Argentina',
    priority: 0,
    timezone: 'America/Argentina/Cordoba',
  },
  AS: {
    areaCodes: null,
    currency: CurrencyCode.USD,
    dialCode: '1684',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AS.png',
    iso2: CountryIso2Code.AS,
    name: 'American Samoa',
    priority: 0,
    timezone: 'Etc/GMT+11',
  },
  AT: {
    areaCodes: null,
    currency: CurrencyCode.EUR,
    dialCode: '43',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AT.png',
    iso2: CountryIso2Code.AT,
    name: 'Austria (Österreich)',
    priority: 0,
    timezone: 'Europe/Vienna',
  },
  AU: {
    areaCodes: null,
    currency: CurrencyCode.AUD,
    dialCode: '61',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AU.png',
    iso2: CountryIso2Code.AU,
    name: 'Australia',
    priority: 0,
    timezone: 'Australia/Darwin',
  },
  AW: {
    areaCodes: null,
    currency: CurrencyCode.AWG,
    dialCode: '297',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AW.png',
    iso2: CountryIso2Code.AW,
    name: 'Aruba',
    priority: 0,
    timezone: 'America/Aruba',
  },
  AX: {
    areaCodes: null,
    currency: CurrencyCode.EUR,
    dialCode: '358',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AX.png',
    iso2: CountryIso2Code.AX,
    name: 'Åland Islands',
    priority: 1,
    timezone: 'Europe/Helsinki',
  },
  AZ: {
    areaCodes: null,
    currency: CurrencyCode.AZN,
    dialCode: '994',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AZ.png',
    iso2: CountryIso2Code.AZ,
    name: 'Azerbaijan (Azərbaycan)',
    priority: 0,
    timezone: 'Asia/Baku',
  },
  BA: {
    areaCodes: null,
    currency: CurrencyCode.BAM,
    dialCode: '387',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BA.png',
    iso2: CountryIso2Code.BA,
    name: 'Bosnia and Herzegovina (Босна и Херцеговина)',
    priority: 0,
    timezone: 'Europe/Sarajevo',
  },
  BB: {
    areaCodes: null,
    currency: CurrencyCode.BBD,
    dialCode: '1246',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BB.png',
    iso2: CountryIso2Code.BB,
    name: 'Barbados',
    priority: 0,
    timezone: 'America/Barbados',
  },
  BD: {
    areaCodes: null,
    currency: CurrencyCode.BDT,
    dialCode: '880',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BD.png',
    iso2: CountryIso2Code.BD,
    name: 'Bangladesh (বাংলাদেশ)',
    priority: 0,
    timezone: 'Asia/Dhaka',
  },
  BE: {
    areaCodes: null,
    currency: CurrencyCode.EUR,
    dialCode: '32',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BE.png',
    iso2: CountryIso2Code.BE,
    name: 'Belgium (België)',
    priority: 0,
    timezone: 'Europe/Brussels',
  },
  BF: {
    areaCodes: null,
    currency: CurrencyCode.XOF,
    dialCode: '226',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BF.png',
    iso2: CountryIso2Code.BF,
    name: 'Burkina Faso',
    priority: 0,
    timezone: 'Africa/Ouagadougou',
  },
  BG: {
    areaCodes: null,
    currency: CurrencyCode.BGN,
    dialCode: '359',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BG.png',
    iso2: CountryIso2Code.BG,
    name: 'Bulgaria (България)',
    priority: 0,
    timezone: 'Europe/Sofia',
  },
  BH: {
    areaCodes: null,
    currency: CurrencyCode.BHD,
    dialCode: '973',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BH.png',
    iso2: CountryIso2Code.BH,
    name: 'Bahrain (‫البحرين‬‎)',
    priority: 0,
    timezone: 'Asia/Bahrain',
  },
  BI: {
    areaCodes: null,
    currency: CurrencyCode.BIF,
    dialCode: '257',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BI.png',
    iso2: CountryIso2Code.BI,
    name: 'Burundi (Uburundi)',
    priority: 0,
    timezone: 'Africa/Bujumbura',
  },
  BJ: {
    areaCodes: null,
    currency: CurrencyCode.XOF,
    dialCode: '229',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BJ.png',
    iso2: CountryIso2Code.BJ,
    name: 'Benin (Bénin)',
    priority: 0,
    timezone: 'Africa/Porto-Novo',
  },
  BL: {
    areaCodes: null,
    currency: CurrencyCode.EUR,
    dialCode: '590',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BL.png',
    iso2: CountryIso2Code.BL,
    name: 'Saint Barthélemy',
    priority: 1,
    timezone: 'America/St_Barthelemy',
  },
  BM: {
    areaCodes: null,
    currency: CurrencyCode.BMD,
    dialCode: '1441',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BM.png',
    iso2: CountryIso2Code.BM,
    name: 'Bermuda',
    priority: 0,
    timezone: 'Atlantic/Bermuda',
  },
  BN: {
    areaCodes: null,
    currency: CurrencyCode.BND,
    dialCode: '673',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BN.png',
    iso2: CountryIso2Code.BN,
    name: 'Brunei',
    priority: 0,
    timezone: 'Asia/Brunei',
  },
  BO: {
    areaCodes: null,
    currency: CurrencyCode.BOB,
    dialCode: '591',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BO.png',
    iso2: CountryIso2Code.BO,
    name: 'Bolivia',
    priority: 0,
    timezone: 'America/La_Paz',
  },
  BQ: {
    areaCodes: null,
    currency: CurrencyCode.USD,
    dialCode: '599',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BQ.png',
    iso2: CountryIso2Code.BQ,
    name: 'Caribbean Netherlands',
    priority: 1,
    timezone: 'America/Kralendijk',
  },
  BR: {
    areaCodes: null,
    currency: CurrencyCode.BRL,
    dialCode: '55',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BR.png',
    iso2: CountryIso2Code.BR,
    name: 'Brazil (Brasil)',
    priority: 0,
    timezone: 'America/Cuiaba',
  },
  BS: {
    areaCodes: null,
    currency: CurrencyCode.BSD,
    dialCode: '1242',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BS.png',
    iso2: CountryIso2Code.BS,
    name: 'Bahamas',
    priority: 0,
    timezone: 'America/Nassau',
  },
  BT: {
    areaCodes: null,
    currency: CurrencyCode.BTN,
    dialCode: '975',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BT.png',
    iso2: CountryIso2Code.BT,
    name: 'Bhutan (འབྲུག)',
    priority: 0,
    timezone: 'Asia/Thimphu',
  },
  BW: {
    areaCodes: null,
    currency: CurrencyCode.BWP,
    dialCode: '267',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BW.png',
    iso2: CountryIso2Code.BW,
    name: 'Botswana',
    priority: 0,
    timezone: 'Africa/Gaborone',
  },
  BY: {
    areaCodes: null,
    currency: CurrencyCode.BYN,
    dialCode: '375',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BY.png',
    iso2: CountryIso2Code.BY,
    name: 'Belarus (Беларусь)',
    priority: 0,
    timezone: 'Europe/Minsk',
  },
  BZ: {
    areaCodes: null,
    currency: CurrencyCode.BZD,
    dialCode: '501',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BZ.png',
    iso2: CountryIso2Code.BZ,
    name: 'Belize',
    priority: 0,
    timezone: 'America/Belize',
  },
  CA: {
    areaCodes: [
      '204',
      '226',
      '236',
      '249',
      '250',
      '289',
      '306',
      '343',
      '365',
      '387',
      '403',
      '416',
      '418',
      '431',
      '437',
      '438',
      '450',
      '506',
      '514',
      '519',
      '548',
      '579',
      '581',
      '587',
      '604',
      '613',
      '639',
      '647',
      '672',
      '705',
      '709',
      '742',
      '778',
      '780',
      '782',
      '807',
      '819',
      '825',
      '867',
      '873',
      '902',
      '905',
    ],
    currency: CurrencyCode.CAD,
    dialCode: '1',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CA.png',
    iso2: CountryIso2Code.CA,
    name: 'Canada',
    priority: 1,
    timezone: 'America/Rankin_Inlet',
  },
  CC: {
    areaCodes: null,
    currency: CurrencyCode.AUD,
    dialCode: '61',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CC.png',
    iso2: CountryIso2Code.CC,
    name: 'Cocos (Keeling) Islands',
    priority: 1,
    timezone: 'Indian/Cocos',
  },
  CD: {
    areaCodes: null,
    currency: CurrencyCode.CDF,
    dialCode: '243',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CD.png',
    iso2: CountryIso2Code.CD,
    name: 'Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)',
    priority: 0,
    timezone: 'Africa/Lubumbashi',
  },
  CF: {
    areaCodes: null,
    currency: CurrencyCode.XAF,
    dialCode: '236',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CF.png',
    iso2: CountryIso2Code.CF,
    name: 'Central African Republic (République centrafricaine)',
    priority: 0,
    timezone: 'Africa/Bangui',
  },
  CG: {
    areaCodes: null,
    currency: CurrencyCode.XAF,
    dialCode: '242',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CG.png',
    iso2: CountryIso2Code.CG,
    name: 'Congo (Republic) (Congo-Brazzaville)',
    priority: 0,
    timezone: 'Africa/Brazzaville',
  },
  CH: {
    areaCodes: null,
    currency: CurrencyCode.CHF,
    dialCode: '41',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CH.png',
    iso2: CountryIso2Code.CH,
    name: 'Switzerland (Schweiz)',
    priority: 0,
    timezone: 'Europe/Zurich',
  },
  CI: {
    areaCodes: null,
    currency: CurrencyCode.XOF,
    dialCode: '225',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CI.png',
    iso2: CountryIso2Code.CI,
    name: 'Côte d’Ivoire',
    priority: 0,
    timezone: 'Africa/Abidjan',
  },
  CK: {
    areaCodes: null,
    currency: CurrencyCode.NZD,
    dialCode: '682',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CK.png',
    iso2: CountryIso2Code.CK,
    name: 'Cook Islands',
    priority: 0,
    timezone: 'Etc/GMT+11',
  },
  CL: {
    areaCodes: null,
    currency: CurrencyCode.CLP,
    dialCode: '56',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CL.png',
    iso2: CountryIso2Code.CL,
    name: 'Chile',
    priority: 0,
    timezone: 'America/Santiago',
  },
  CM: {
    areaCodes: null,
    currency: CurrencyCode.XAF,
    dialCode: '237',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CM.png',
    iso2: CountryIso2Code.CM,
    name: 'Cameroon (Cameroun)',
    priority: 0,
    timezone: 'Africa/Douala',
  },
  CN: {
    areaCodes: null,
    currency: CurrencyCode.CNY,
    dialCode: '86',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CN.png',
    iso2: CountryIso2Code.CN,
    name: 'China (中国)',
    priority: 0,
    timezone: 'Asia/Shanghai',
  },
  CO: {
    areaCodes: null,
    currency: CurrencyCode.COP,
    dialCode: '57',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CO.png',
    iso2: CountryIso2Code.CO,
    name: 'Colombia',
    priority: 0,
    timezone: 'America/Bogota',
  },
  CR: {
    areaCodes: null,
    currency: CurrencyCode.CRC,
    dialCode: '506',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CR.png',
    iso2: CountryIso2Code.CR,
    name: 'Costa Rica',
    priority: 0,
    timezone: 'America/Costa_Rica',
  },
  CU: {
    areaCodes: null,
    currency: CurrencyCode.CUP,
    dialCode: '53',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CU.png',
    iso2: CountryIso2Code.CU,
    name: 'Cuba',
    priority: 0,
    timezone: 'America/Havana',
  },
  CV: {
    areaCodes: null,
    currency: CurrencyCode.CVE,
    dialCode: '238',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CV.png',
    iso2: CountryIso2Code.CV,
    name: 'Cape Verde (Kabu Verdi)',
    priority: 0,
    timezone: 'Atlantic/Cape_Verde',
  },
  CW: {
    areaCodes: null,
    currency: CurrencyCode.ANG,
    dialCode: '599',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CW.png',
    iso2: CountryIso2Code.CW,
    name: 'Curaçao',
    priority: 0,
    timezone: 'America/Curacao',
  },
  CX: {
    areaCodes: null,
    currency: CurrencyCode.AUD,
    dialCode: '61',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CX.png',
    iso2: CountryIso2Code.CX,
    name: 'Christmas Island',
    priority: 2,
    timezone: 'Indian/Christmas',
  },
  CY: {
    areaCodes: null,
    currency: CurrencyCode.EUR,
    dialCode: '357',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CY.png',
    iso2: CountryIso2Code.CY,
    name: 'Cyprus (Κύπρος)',
    priority: 0,
    timezone: 'Asia/Nicosia',
  },
  CZ: {
    areaCodes: null,
    currency: CurrencyCode.CZK,
    dialCode: '420',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CZ.png',
    iso2: CountryIso2Code.CZ,
    name: 'Czech Republic (Česká republika)',
    priority: 0,
    timezone: 'Europe/Prague',
  },
  DE: {
    areaCodes: null,
    currency: CurrencyCode.EUR,
    dialCode: '49',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/DE.png',
    iso2: CountryIso2Code.DE,
    name: 'Germany (Deutschland)',
    priority: 0,
    timezone: 'Europe/Berlin',
  },
  DJ: {
    areaCodes: null,
    currency: CurrencyCode.DJF,
    dialCode: '253',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/DJ.png',
    iso2: CountryIso2Code.DJ,
    name: 'Djibouti',
    priority: 0,
    timezone: 'Africa/Djibouti',
  },
  DK: {
    areaCodes: null,
    currency: CurrencyCode.DKK,
    dialCode: '45',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/DK.png',
    iso2: CountryIso2Code.DK,
    name: 'Denmark (Danmark)',
    priority: 0,
    timezone: 'Europe/Copenhagen',
  },
  DM: {
    areaCodes: null,
    currency: CurrencyCode.XCD,
    dialCode: '1767',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/DM.png',
    iso2: CountryIso2Code.DM,
    name: 'Dominica',
    priority: 0,
    timezone: 'America/Dominica',
  },
  DO: {
    areaCodes: ['809', '829', '849'],
    currency: CurrencyCode.DOP,
    dialCode: '1',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/DO.png',
    iso2: CountryIso2Code.DO,
    name: 'Dominican Republic (República Dominicana)',
    priority: 2,
    timezone: 'America/Santo_Domingo',
  },
  DZ: {
    areaCodes: null,
    currency: CurrencyCode.DZD,
    dialCode: '213',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/DZ.png',
    iso2: CountryIso2Code.DZ,
    name: 'Algeria (‫الجزائر‬‎)',
    priority: 0,
    timezone: 'Africa/Algiers',
  },
  EC: {
    areaCodes: null,
    currency: CurrencyCode.USD,
    dialCode: '593',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/EC.png',
    iso2: CountryIso2Code.EC,
    name: 'Ecuador',
    priority: 0,
    timezone: 'America/Guayaquil',
  },
  EE: {
    areaCodes: null,
    currency: CurrencyCode.EUR,
    dialCode: '372',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/EE.png',
    iso2: CountryIso2Code.EE,
    name: 'Estonia (Eesti)',
    priority: 0,
    timezone: 'Europe/Tallinn',
  },
  EG: {
    areaCodes: null,
    currency: CurrencyCode.EGP,
    dialCode: '20',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/EG.png',
    iso2: CountryIso2Code.EG,
    name: 'Egypt (‫مصر‬‎)',
    priority: 0,
    timezone: 'Africa/Cairo',
  },
  EH: {
    areaCodes: null,
    currency: CurrencyCode.MAD,
    dialCode: '212',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/EH.png',
    iso2: CountryIso2Code.EH,
    name: 'Western Sahara (‫الصحراء الغربية‬‎)',
    priority: 1,
    timezone: 'Africa/El_Aaiun',
  },
  ER: {
    areaCodes: null,
    currency: CurrencyCode.ERN,
    dialCode: '291',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ER.png',
    iso2: CountryIso2Code.ER,
    name: 'Eritrea',
    priority: 0,
    timezone: 'Africa/Asmara',
  },
  ES: {
    areaCodes: null,
    currency: CurrencyCode.EUR,
    dialCode: '34',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ES.png',
    iso2: CountryIso2Code.ES,
    name: 'Spain (España)',
    priority: 0,
    timezone: 'Europe/Madrid',
  },
  ET: {
    areaCodes: null,
    currency: CurrencyCode.ETB,
    dialCode: '251',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ET.png',
    iso2: CountryIso2Code.ET,
    name: 'Ethiopia',
    priority: 0,
    timezone: 'Africa/Addis_Ababa',
  },
  FI: {
    areaCodes: null,
    currency: CurrencyCode.EUR,
    dialCode: '358',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/FI.png',
    iso2: CountryIso2Code.FI,
    name: 'Finland (Suomi)',
    priority: 0,
    timezone: 'Europe/Helsinki',
  },
  FJ: {
    areaCodes: null,
    currency: CurrencyCode.FJD,
    dialCode: '679',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/FJ.png',
    iso2: CountryIso2Code.FJ,
    name: 'Fiji',
    priority: 0,
    timezone: 'Pacific/Fiji',
  },
  FK: {
    areaCodes: null,
    currency: CurrencyCode.FKP,
    dialCode: '500',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/FK.png',
    iso2: CountryIso2Code.FK,
    name: 'Falkland Islands (Islas Malvinas)',
    priority: 0,
    timezone: 'Atlantic/Stanley',
  },
  FM: {
    areaCodes: null,
    currency: CurrencyCode.USD,
    dialCode: '691',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/FM.png',
    iso2: CountryIso2Code.FM,
    name: 'Micronesia',
    priority: 0,
    timezone: 'Etc/GMT-10',
  },
  FO: {
    areaCodes: null,
    currency: CurrencyCode.DKK,
    dialCode: '298',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/FO.png',
    iso2: CountryIso2Code.FO,
    name: 'Faroe Islands (Føroyar)',
    priority: 0,
    timezone: 'Atlantic/Faroe',
  },
  FR: {
    areaCodes: null,
    currency: CurrencyCode.EUR,
    dialCode: '33',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/FR.png',
    iso2: CountryIso2Code.FR,
    name: 'France',
    priority: 0,
    timezone: 'Europe/Paris',
  },
  GA: {
    areaCodes: null,
    currency: CurrencyCode.XAF,
    dialCode: '241',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GA.png',
    iso2: CountryIso2Code.GA,
    name: 'Gabon',
    priority: 0,
    timezone: 'Africa/Libreville',
  },
  GB: {
    areaCodes: null,
    currency: CurrencyCode.GBP,
    dialCode: '44',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GB.png',
    iso2: CountryIso2Code.GB,
    name: 'United Kingdom',
    priority: 0,
    timezone: 'Etc/GMT',
  },
  GD: {
    areaCodes: null,
    currency: CurrencyCode.XCD,
    dialCode: '1473',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GD.png',
    iso2: CountryIso2Code.GD,
    name: 'Grenada',
    priority: 0,
    timezone: 'America/Grenada',
  },
  GE: {
    areaCodes: null,
    currency: CurrencyCode.GEL,
    dialCode: '995',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GE.png',
    iso2: CountryIso2Code.GE,
    name: 'Georgia (საქართველო)',
    priority: 0,
    timezone: 'Asia/Tbilisi',
  },
  GF: {
    areaCodes: null,
    currency: CurrencyCode.EUR,
    dialCode: '594',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GF.png',
    iso2: CountryIso2Code.GF,
    name: 'French Guiana (Guyane française)',
    priority: 0,
    timezone: 'America/Cayenne',
  },
  GG: {
    areaCodes: null,
    currency: CurrencyCode.GBP,
    dialCode: '44',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GG.png',
    iso2: CountryIso2Code.GG,
    name: 'Guernsey',
    priority: 1,
    timezone: 'Europe/Guernsey',
  },
  GH: {
    areaCodes: null,
    currency: CurrencyCode.GHS,
    dialCode: '233',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GH.png',
    iso2: CountryIso2Code.GH,
    name: 'Ghana (Gaana)',
    priority: 0,
    timezone: 'Africa/Accra',
  },
  GI: {
    areaCodes: null,
    currency: CurrencyCode.GIP,
    dialCode: '350',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GI.png',
    iso2: CountryIso2Code.GI,
    name: 'Gibraltar',
    priority: 0,
    timezone: 'Europe/Gibraltar',
  },
  GL: {
    areaCodes: null,
    currency: CurrencyCode.DKK,
    dialCode: '299',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GL.png',
    iso2: CountryIso2Code.GL,
    name: 'Greenland (Kalaallit Nunaat)',
    priority: 0,
    timezone: 'America/Godthab',
  },
  GM: {
    areaCodes: null,
    currency: CurrencyCode.GMD,
    dialCode: '220',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GM.png',
    iso2: CountryIso2Code.GM,
    name: 'Gambia',
    priority: 0,
    timezone: 'Africa/Banjul',
  },
  GN: {
    areaCodes: null,
    currency: CurrencyCode.GNF,
    dialCode: '224',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GN.png',
    iso2: CountryIso2Code.GN,
    name: 'Guinea (Guinée)',
    priority: 0,
    timezone: 'Africa/Conakry',
  },
  GP: {
    areaCodes: null,
    currency: CurrencyCode.EUR,
    dialCode: '590',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GP.png',
    iso2: CountryIso2Code.GP,
    name: 'Guadeloupe',
    priority: 0,
    timezone: 'America/Guadeloupe',
  },
  GQ: {
    areaCodes: null,
    currency: CurrencyCode.XAF,
    dialCode: '240',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GQ.png',
    iso2: CountryIso2Code.GQ,
    name: 'Equatorial Guinea (Guinea Ecuatorial)',
    priority: 0,
    timezone: 'Africa/Malabo',
  },
  GR: {
    areaCodes: null,
    currency: CurrencyCode.EUR,
    dialCode: '30',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GR.png',
    iso2: CountryIso2Code.GR,
    name: 'Greece (Ελλάδα)',
    priority: 0,
    timezone: 'Europe/Athens',
  },
  GT: {
    areaCodes: null,
    currency: CurrencyCode.GTQ,
    dialCode: '502',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GT.png',
    iso2: CountryIso2Code.GT,
    name: 'Guatemala',
    priority: 0,
    timezone: 'America/Guatemala',
  },
  GU: {
    areaCodes: null,
    currency: CurrencyCode.USD,
    dialCode: '1671',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GU.png',
    iso2: CountryIso2Code.GU,
    name: 'Guam',
    priority: 0,
    timezone: 'Pacific/Guam',
  },
  GW: {
    areaCodes: null,
    currency: CurrencyCode.XOF,
    dialCode: '245',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GW.png',
    iso2: CountryIso2Code.GW,
    name: 'Guinea-Bissau (Guiné Bissau)',
    priority: 0,
    timezone: 'Africa/Bissau',
  },
  GY: {
    areaCodes: null,
    currency: CurrencyCode.GYD,
    dialCode: '592',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GY.png',
    iso2: CountryIso2Code.GY,
    name: 'Guyana',
    priority: 0,
    timezone: 'America/Guyana',
  },
  HK: {
    areaCodes: null,
    currency: CurrencyCode.HKD,
    dialCode: '852',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/HK.png',
    iso2: CountryIso2Code.HK,
    name: 'Hong Kong (香港)',
    priority: 0,
    timezone: 'Asia/Hong_Kong',
  },
  HN: {
    areaCodes: null,
    currency: CurrencyCode.HNL,
    dialCode: '504',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/HN.png',
    iso2: CountryIso2Code.HN,
    name: 'Honduras',
    priority: 0,
    timezone: 'America/Tegucigalpa',
  },
  HR: {
    areaCodes: null,
    currency: CurrencyCode.EUR,
    dialCode: '385',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/HR.png',
    iso2: CountryIso2Code.HR,
    name: 'Croatia (Hrvatska)',
    priority: 0,
    timezone: 'Europe/Zagreb',
  },
  HT: {
    areaCodes: null,
    currency: CurrencyCode.HTG,
    dialCode: '509',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/HT.png',
    iso2: CountryIso2Code.HT,
    name: 'Haiti',
    priority: 0,
    timezone: 'America/Port-au-Prince',
  },
  HU: {
    areaCodes: null,
    currency: CurrencyCode.HUF,
    dialCode: '36',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/HU.png',
    iso2: CountryIso2Code.HU,
    name: 'Hungary (Magyarország)',
    priority: 0,
    timezone: 'Europe/Budapest',
  },
  ID: {
    areaCodes: null,
    currency: CurrencyCode.IDR,
    dialCode: '62',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ID.png',
    iso2: CountryIso2Code.ID,
    name: 'Indonesia',
    priority: 0,
    timezone: 'Asia/Makassar',
  },
  IE: {
    areaCodes: null,
    currency: CurrencyCode.EUR,
    dialCode: '353',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IE.png',
    iso2: CountryIso2Code.IE,
    name: 'Ireland',
    priority: 0,
    timezone: 'Europe/Dublin',
  },
  IL: {
    areaCodes: null,
    currency: CurrencyCode.ILS,
    dialCode: '972',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IL.png',
    iso2: CountryIso2Code.IL,
    name: 'Israel (‫ישראל‬‎)',
    priority: 0,
    timezone: 'Asia/Jerusalem',
  },
  IM: {
    areaCodes: null,
    currency: CurrencyCode.GBP,
    dialCode: '44',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IM.png',
    iso2: CountryIso2Code.IM,
    name: 'Isle of Man',
    priority: 2,
    timezone: 'Europe/Isle_of_Man',
  },
  IN: {
    areaCodes: null,
    currency: CurrencyCode.INR,
    dialCode: '91',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IN.png',
    iso2: CountryIso2Code.IN,
    name: 'India (भारत)',
    priority: 0,
    timezone: 'Asia/Kolkata',
  },
  IO: {
    areaCodes: null,
    currency: CurrencyCode.USD,
    dialCode: '246',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IO.png',
    iso2: CountryIso2Code.IO,
    name: 'British Indian Ocean Territory',
    priority: 0,
    timezone: 'Etc/GMT-5',
  },
  IQ: {
    areaCodes: null,
    currency: CurrencyCode.IQD,
    dialCode: '964',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IQ.png',
    iso2: CountryIso2Code.IQ,
    name: 'Iraq (‫العراق‬‎)',
    priority: 0,
    timezone: 'Asia/Baghdad',
  },
  IR: {
    areaCodes: null,
    currency: CurrencyCode.IRR,
    dialCode: '98',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IR.png',
    iso2: CountryIso2Code.IR,
    name: 'Iran (‫ایران‬‎)',
    priority: 0,
    timezone: 'Asia/Tehran',
  },
  IS: {
    areaCodes: null,
    currency: CurrencyCode.ISK,
    dialCode: '354',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IS.png',
    iso2: CountryIso2Code.IS,
    name: 'Iceland (Ísland)',
    priority: 0,
    timezone: 'Atlantic/Reykjavik',
  },
  IT: {
    areaCodes: null,
    currency: CurrencyCode.EUR,
    dialCode: '39',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IT.png',
    iso2: CountryIso2Code.IT,
    name: 'Italy (Italia)',
    priority: 0,
    timezone: 'Europe/Rome',
  },
  JE: {
    areaCodes: null,
    currency: CurrencyCode.GBP,
    dialCode: '44',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/JE.png',
    iso2: CountryIso2Code.JE,
    name: 'Jersey',
    priority: 3,
    timezone: 'Europe/Jersey',
  },
  JM: {
    areaCodes: null,
    currency: CurrencyCode.JMD,
    dialCode: '1876',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/JM.png',
    iso2: CountryIso2Code.JM,
    name: 'Jamaica',
    priority: 0,
    timezone: 'America/Jamaica',
  },
  JO: {
    areaCodes: null,
    currency: CurrencyCode.JOD,
    dialCode: '962',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/JO.png',
    iso2: CountryIso2Code.JO,
    name: 'Jordan (‫الأردن‬‎)',
    priority: 0,
    timezone: 'Asia/Amman',
  },
  JP: {
    areaCodes: null,
    currency: CurrencyCode.JPY,
    dialCode: '81',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/JP.png',
    iso2: CountryIso2Code.JP,
    name: 'Japan (日本)',
    priority: 0,
    timezone: 'Asia/Tokyo',
  },
  KE: {
    areaCodes: null,
    currency: CurrencyCode.KES,
    dialCode: '254',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KE.png',
    iso2: CountryIso2Code.KE,
    name: 'Kenya',
    priority: 0,
    timezone: 'Africa/Nairobi',
  },
  KG: {
    areaCodes: null,
    currency: CurrencyCode.KGS,
    dialCode: '996',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KG.png',
    iso2: CountryIso2Code.KG,
    name: 'Kyrgyzstan (Кыргызстан)',
    priority: 0,
    timezone: 'Asia/Bishkek',
  },
  KH: {
    areaCodes: null,
    currency: CurrencyCode.KHR,
    dialCode: '855',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KH.png',
    iso2: CountryIso2Code.KH,
    name: 'Cambodia (កម្ពុជា)',
    priority: 0,
    timezone: 'Asia/Phnom_Penh',
  },
  KI: {
    areaCodes: null,
    currency: CurrencyCode.AUD,
    dialCode: '686',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KI.png',
    iso2: CountryIso2Code.KI,
    name: 'Kiribati',
    priority: 0,
    timezone: 'Etc/GMT+11',
  },
  KM: {
    areaCodes: null,
    currency: CurrencyCode.KMF,
    dialCode: '269',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KM.png',
    iso2: CountryIso2Code.KM,
    name: 'Comoros (‫جزر القمر‬‎)',
    priority: 0,
    timezone: 'Indian/Comoro',
  },
  KN: {
    areaCodes: null,
    currency: CurrencyCode.XCD,
    dialCode: '1869',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KN.png',
    iso2: CountryIso2Code.KN,
    name: 'Saint Kitts and Nevis',
    priority: 0,
    timezone: 'America/St_Kitts',
  },
  KP: {
    areaCodes: null,
    currency: CurrencyCode.KPW,
    dialCode: '850',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KP.png',
    iso2: CountryIso2Code.KP,
    name: 'North Korea (조선 민주주의 인민 공화국)',
    priority: 0,
    timezone: 'Asia/Pyongyang',
  },
  KR: {
    areaCodes: null,
    currency: CurrencyCode.KRW,
    dialCode: '82',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KR.png',
    iso2: CountryIso2Code.KR,
    name: 'South Korea (대한민국)',
    priority: 0,
    timezone: 'Asia/Seoul',
  },
  KW: {
    areaCodes: null,
    currency: CurrencyCode.KWD,
    dialCode: '965',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KW.png',
    iso2: CountryIso2Code.KW,
    name: 'Kuwait (‫الكويت‬‎)',
    priority: 0,
    timezone: 'Asia/Kuwait',
  },
  KY: {
    areaCodes: null,
    currency: CurrencyCode.KYD,
    dialCode: '1345',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KY.png',
    iso2: CountryIso2Code.KY,
    name: 'Cayman Islands',
    priority: 0,
    timezone: 'Etc/GMT+5',
  },
  KZ: {
    areaCodes: null,
    currency: CurrencyCode.KZT,
    dialCode: '7',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KZ.png',
    iso2: CountryIso2Code.KZ,
    name: 'Kazakhstan (Казахстан)',
    priority: 1,
    timezone: 'Asia/Almaty',
  },
  LA: {
    areaCodes: null,
    currency: CurrencyCode.LAK,
    dialCode: '856',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LA.png',
    iso2: CountryIso2Code.LA,
    name: 'Laos (ລາວ)',
    priority: 0,
    timezone: 'Asia/Vientiane',
  },
  LB: {
    areaCodes: null,
    currency: CurrencyCode.LBP,
    dialCode: '961',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LB.png',
    iso2: CountryIso2Code.LB,
    name: 'Lebanon (‫لبنان‬‎)',
    priority: 0,
    timezone: 'Asia/Beirut',
  },
  LC: {
    areaCodes: null,
    currency: CurrencyCode.XCD,
    dialCode: '1758',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LC.png',
    iso2: CountryIso2Code.LC,
    name: 'Saint Lucia',
    priority: 0,
    timezone: 'America/St_Lucia',
  },
  LI: {
    areaCodes: null,
    currency: CurrencyCode.CHF,
    dialCode: '423',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LI.png',
    iso2: CountryIso2Code.LI,
    name: 'Liechtenstein',
    priority: 0,
    timezone: 'Europe/Vaduz',
  },
  LK: {
    areaCodes: null,
    currency: CurrencyCode.LKR,
    dialCode: '94',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LK.png',
    iso2: CountryIso2Code.LK,
    name: 'Sri Lanka (ශ්‍රී ලංකාව)',
    priority: 0,
    timezone: 'Asia/Colombo',
  },
  LR: {
    areaCodes: null,
    currency: CurrencyCode.LRD,
    dialCode: '231',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LR.png',
    iso2: CountryIso2Code.LR,
    name: 'Liberia',
    priority: 0,
    timezone: 'Africa/Monrovia',
  },
  LS: {
    areaCodes: null,
    currency: CurrencyCode.LSL,
    dialCode: '266',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LS.png',
    iso2: CountryIso2Code.LS,
    name: 'Lesotho',
    priority: 0,
    timezone: 'Africa/Maseru',
  },
  LT: {
    areaCodes: null,
    currency: CurrencyCode.EUR,
    dialCode: '370',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LT.png',
    iso2: CountryIso2Code.LT,
    name: 'Lithuania (Lietuva)',
    priority: 0,
    timezone: 'Europe/Vilnius',
  },
  LU: {
    areaCodes: null,
    currency: CurrencyCode.EUR,
    dialCode: '352',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LU.png',
    iso2: CountryIso2Code.LU,
    name: 'Luxembourg',
    priority: 0,
    timezone: 'Europe/Luxembourg',
  },
  LV: {
    areaCodes: null,
    currency: CurrencyCode.EUR,
    dialCode: '371',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LV.png',
    iso2: CountryIso2Code.LV,
    name: 'Latvia (Latvija)',
    priority: 0,
    timezone: 'Europe/Riga',
  },
  LY: {
    areaCodes: null,
    currency: CurrencyCode.LYD,
    dialCode: '218',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LY.png',
    iso2: CountryIso2Code.LY,
    name: 'Libya (‫ليبيا‬‎)',
    priority: 0,
    timezone: 'Africa/Tripoli',
  },
  MA: {
    areaCodes: null,
    currency: CurrencyCode.MAD,
    dialCode: '212',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MA.png',
    iso2: CountryIso2Code.MA,
    name: 'Morocco (‫المغرب‬‎)',
    priority: 0,
    timezone: 'Africa/Casablanca',
  },
  MC: {
    areaCodes: null,
    currency: CurrencyCode.EUR,
    dialCode: '377',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MC.png',
    iso2: CountryIso2Code.MC,
    name: 'Monaco',
    priority: 0,
    timezone: 'Europe/Paris',
  },
  MD: {
    areaCodes: null,
    currency: CurrencyCode.MDL,
    dialCode: '373',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MD.png',
    iso2: CountryIso2Code.MD,
    name: 'Moldova (Republica Moldova)',
    priority: 0,
    timezone: 'Europe/Chisinau',
  },
  ME: {
    areaCodes: null,
    currency: CurrencyCode.EUR,
    dialCode: '382',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ME.png',
    iso2: CountryIso2Code.ME,
    name: 'Montenegro (Crna Gora)',
    priority: 0,
    timezone: 'Europe/Podgorica',
  },
  MF: {
    areaCodes: null,
    currency: CurrencyCode.EUR,
    dialCode: '590',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MF.png',
    iso2: CountryIso2Code.MF,
    name: 'Saint Martin (Saint-Martin (partie française))',
    priority: 2,
    timezone: 'America/Marigot',
  },
  MG: {
    areaCodes: null,
    currency: CurrencyCode.MGA,
    dialCode: '261',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MG.png',
    iso2: CountryIso2Code.MG,
    name: 'Madagascar (Madagasikara)',
    priority: 0,
    timezone: 'Indian/Antananarivo',
  },
  MH: {
    areaCodes: null,
    currency: CurrencyCode.USD,
    dialCode: '692',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MH.png',
    iso2: CountryIso2Code.MH,
    name: 'Marshall Islands',
    priority: 0,
    timezone: 'Etc/GMT-11',
  },
  MK: {
    areaCodes: null,
    currency: CurrencyCode.MKD,
    dialCode: '389',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MK.png',
    iso2: CountryIso2Code.MK,
    name: 'Macedonia (FYROM) (Македонија)',
    priority: 0,
    timezone: 'Europe/Skopje',
  },
  ML: {
    areaCodes: null,
    currency: CurrencyCode.XOF,
    dialCode: '223',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ML.png',
    iso2: CountryIso2Code.ML,
    name: 'Mali',
    priority: 0,
    timezone: 'Africa/Bamako',
  },
  MM: {
    areaCodes: null,
    currency: CurrencyCode.MMK,
    dialCode: '95',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MM.png',
    iso2: CountryIso2Code.MM,
    name: 'Myanmar (Burma) (မြန်မာ)',
    priority: 0,
    timezone: 'Asia/Yangon',
  },
  MN: {
    areaCodes: null,
    currency: CurrencyCode.MNT,
    dialCode: '976',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MN.png',
    iso2: CountryIso2Code.MN,
    name: 'Mongolia (Монгол)',
    priority: 0,
    timezone: 'Asia/Ulaanbaatar',
  },
  MO: {
    areaCodes: null,
    currency: CurrencyCode.MOP,
    dialCode: '853',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MO.png',
    iso2: CountryIso2Code.MO,
    name: 'Macau (澳門)',
    priority: 0,
    timezone: 'Asia/Macau',
  },
  MP: {
    areaCodes: null,
    currency: CurrencyCode.USD,
    dialCode: '1670',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MP.png',
    iso2: CountryIso2Code.MP,
    name: 'Northern Mariana Islands',
    priority: 0,
    timezone: 'Pacific/Saipan',
  },
  MQ: {
    areaCodes: null,
    currency: CurrencyCode.EUR,
    dialCode: '596',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MQ.png',
    iso2: CountryIso2Code.MQ,
    name: 'Martinique',
    priority: 0,
    timezone: 'America/Martinique',
  },
  MR: {
    areaCodes: null,
    currency: CurrencyCode.MRU,
    dialCode: '222',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MR.png',
    iso2: CountryIso2Code.MR,
    name: 'Mauritania (‫موريتانيا‬‎)',
    priority: 0,
    timezone: 'Africa/Nouakchott',
  },
  MS: {
    areaCodes: null,
    currency: CurrencyCode.XCD,
    dialCode: '1664',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MS.png',
    iso2: CountryIso2Code.MS,
    name: 'Montserrat',
    priority: 0,
    timezone: 'America/Montserrat',
  },
  MT: {
    areaCodes: null,
    currency: CurrencyCode.EUR,
    dialCode: '356',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MT.png',
    iso2: CountryIso2Code.MT,
    name: 'Malta',
    priority: 0,
    timezone: 'Europe/Malta',
  },
  MU: {
    areaCodes: null,
    currency: CurrencyCode.MUR,
    dialCode: '230',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MU.png',
    iso2: CountryIso2Code.MU,
    name: 'Mauritius (Moris)',
    priority: 0,
    timezone: 'Indian/Mauritius',
  },
  MV: {
    areaCodes: null,
    currency: CurrencyCode.MVR,
    dialCode: '960',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MV.png',
    iso2: CountryIso2Code.MV,
    name: 'Maldives',
    priority: 0,
    timezone: 'Indian/Maldives',
  },
  MW: {
    areaCodes: null,
    currency: CurrencyCode.MWK,
    dialCode: '265',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MW.png',
    iso2: CountryIso2Code.MW,
    name: 'Malawi',
    priority: 0,
    timezone: 'Africa/Blantyre',
  },
  MX: {
    areaCodes: null,
    currency: CurrencyCode.MXN,
    dialCode: '52',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MX.png',
    iso2: CountryIso2Code.MX,
    name: 'Mexico (México)',
    priority: 0,
    timezone: 'America/Mexico_City',
  },
  MY: {
    areaCodes: null,
    currency: CurrencyCode.MYR,
    dialCode: '60',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MY.png',
    iso2: CountryIso2Code.MY,
    name: 'Malaysia',
    priority: 0,
    timezone: 'Asia/Kuching',
  },
  MZ: {
    areaCodes: null,
    currency: CurrencyCode.MZN,
    dialCode: '258',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MZ.png',
    iso2: CountryIso2Code.MZ,
    name: 'Mozambique (Moçambique)',
    priority: 0,
    timezone: 'Africa/Maputo',
  },
  NA: {
    areaCodes: null,
    currency: CurrencyCode.NAD,
    dialCode: '264',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NA.png',
    iso2: CountryIso2Code.NA,
    name: 'Namibia (Namibië)',
    priority: 0,
    timezone: 'Africa/Windhoek',
  },
  NC: {
    areaCodes: null,
    currency: CurrencyCode.XPF,
    dialCode: '687',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NC.png',
    iso2: CountryIso2Code.NC,
    name: 'New Caledonia (Nouvelle-Calédonie)',
    priority: 0,
    timezone: 'Pacific/Noumea',
  },
  NE: {
    areaCodes: null,
    currency: CurrencyCode.XOF,
    dialCode: '227',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NE.png',
    iso2: CountryIso2Code.NE,
    name: 'Niger (Nijar)',
    priority: 0,
    timezone: 'Africa/Niamey',
  },
  NF: {
    areaCodes: null,
    currency: CurrencyCode.AUD,
    dialCode: '672',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NF.png',
    iso2: CountryIso2Code.NF,
    name: 'Norfolk Island',
    priority: 0,
    timezone: 'Pacific/Norfolk',
  },
  NG: {
    areaCodes: null,
    currency: CurrencyCode.NGN,
    dialCode: '234',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NG.png',
    iso2: CountryIso2Code.NG,
    name: 'Nigeria',
    priority: 0,
    timezone: 'Africa/Lagos',
  },
  NI: {
    areaCodes: null,
    currency: CurrencyCode.NIO,
    dialCode: '505',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NI.png',
    iso2: CountryIso2Code.NI,
    name: 'Nicaragua',
    priority: 0,
    timezone: 'America/Managua',
  },
  NL: {
    areaCodes: null,
    currency: CurrencyCode.EUR,
    dialCode: '31',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NL.png',
    iso2: CountryIso2Code.NL,
    name: 'Netherlands (Nederland)',
    priority: 0,
    timezone: 'Europe/Amsterdam',
  },
  NO: {
    areaCodes: null,
    currency: CurrencyCode.NOK,
    dialCode: '47',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NO.png',
    iso2: CountryIso2Code.NO,
    name: 'Norway (Norge)',
    priority: 0,
    timezone: 'Europe/Oslo',
  },
  NP: {
    areaCodes: null,
    currency: CurrencyCode.NPR,
    dialCode: '977',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NP.png',
    iso2: CountryIso2Code.NP,
    name: 'Nepal (नेपाल)',
    priority: 0,
    timezone: 'Asia/Kathmandu',
  },
  NR: {
    areaCodes: null,
    currency: CurrencyCode.AUD,
    dialCode: '674',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NR.png',
    iso2: CountryIso2Code.NR,
    name: 'Nauru',
    priority: 0,
    timezone: 'Pacific/Nauru',
  },
  NU: {
    areaCodes: null,
    currency: CurrencyCode.NZD,
    dialCode: '683',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NU.png',
    iso2: CountryIso2Code.NU,
    name: 'Niue',
    priority: 0,
    timezone: 'Pacific/Niue',
  },
  NZ: {
    areaCodes: null,
    currency: CurrencyCode.NZD,
    dialCode: '64',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NZ.png',
    iso2: CountryIso2Code.NZ,
    name: 'New Zealand',
    priority: 0,
    timezone: 'Pacific/Auckland',
  },
  OM: {
    areaCodes: null,
    currency: CurrencyCode.OMR,
    dialCode: '968',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/OM.png',
    iso2: CountryIso2Code.OM,
    name: 'Oman (‫عُمان‬‎)',
    priority: 0,
    timezone: 'Asia/Muscat',
  },
  PA: {
    areaCodes: null,
    currency: CurrencyCode.PAB,
    dialCode: '507',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PA.png',
    iso2: CountryIso2Code.PA,
    name: 'Panama (Panamá)',
    priority: 0,
    timezone: 'America/Panama',
  },
  PE: {
    areaCodes: null,
    currency: CurrencyCode.PEN,
    dialCode: '51',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PE.png',
    iso2: CountryIso2Code.PE,
    name: 'Peru (Perú)',
    priority: 0,
    timezone: 'America/Lima',
  },
  PF: {
    areaCodes: null,
    currency: CurrencyCode.XPF,
    dialCode: '689',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PF.png',
    iso2: CountryIso2Code.PF,
    name: 'French Polynesia (Polynésie française)',
    priority: 0,
    timezone: 'Etc/GMT+9',
  },
  PG: {
    areaCodes: null,
    currency: CurrencyCode.PGK,
    dialCode: '675',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PG.png',
    iso2: CountryIso2Code.PG,
    name: 'Papua New Guinea',
    priority: 0,
    timezone: 'Pacific/Port_Moresby',
  },
  PH: {
    areaCodes: null,
    currency: CurrencyCode.PHP,
    dialCode: '63',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PH.png',
    iso2: CountryIso2Code.PH,
    name: 'Philippines',
    priority: 0,
    timezone: 'Asia/Manila',
  },
  PK: {
    areaCodes: null,
    currency: CurrencyCode.PKR,
    dialCode: '92',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PK.png',
    iso2: CountryIso2Code.PK,
    name: 'Pakistan (‫پاکستان‬‎)',
    priority: 0,
    timezone: 'Asia/Karachi',
  },
  PL: {
    areaCodes: null,
    currency: CurrencyCode.PLN,
    dialCode: '48',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PL.png',
    iso2: CountryIso2Code.PL,
    name: 'Poland (Polska)',
    priority: 0,
    timezone: 'Europe/Warsaw',
  },
  PM: {
    areaCodes: null,
    currency: CurrencyCode.EUR,
    dialCode: '508',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PM.png',
    iso2: CountryIso2Code.PM,
    name: 'Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)',
    priority: 0,
    timezone: 'America/Miquelon',
  },
  PR: {
    areaCodes: ['787', '939'],
    currency: CurrencyCode.USD,
    dialCode: '1',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PR.png',
    iso2: CountryIso2Code.PR,
    name: 'Puerto Rico',
    priority: 3,
    timezone: 'America/Puerto_Rico',
  },
  PS: {
    areaCodes: null,
    currency: CurrencyCode.ILS,
    dialCode: '970',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PS.png',
    iso2: CountryIso2Code.PS,
    name: 'Palestine (‫فلسطين‬‎)',
    priority: 0,
    timezone: 'Asia/Jerusalem',
  },
  PT: {
    areaCodes: null,
    currency: CurrencyCode.EUR,
    dialCode: '351',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PT.png',
    iso2: CountryIso2Code.PT,
    name: 'Portugal',
    priority: 0,
    timezone: 'Europe/Lisbon',
  },
  PW: {
    areaCodes: null,
    currency: CurrencyCode.USD,
    dialCode: '680',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PW.png',
    iso2: CountryIso2Code.PW,
    name: 'Palau',
    priority: 0,
    timezone: 'Etc/GMT-9',
  },
  PY: {
    areaCodes: null,
    currency: CurrencyCode.PYG,
    dialCode: '595',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PY.png',
    iso2: CountryIso2Code.PY,
    name: 'Paraguay',
    priority: 0,
    timezone: 'America/Asuncion',
  },
  QA: {
    areaCodes: null,
    currency: CurrencyCode.QAR,
    dialCode: '974',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/QA.png',
    iso2: CountryIso2Code.QA,
    name: 'Qatar (‫قطر‬‎)',
    priority: 0,
    timezone: 'Asia/Qatar',
  },
  RE: {
    areaCodes: null,
    currency: CurrencyCode.EUR,
    dialCode: '262',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/RE.png',
    iso2: CountryIso2Code.RE,
    name: 'Réunion (La Réunion)',
    priority: 0,
    timezone: 'Indian/Reunion',
  },
  RO: {
    areaCodes: null,
    currency: CurrencyCode.RON,
    dialCode: '40',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/RO.png',
    iso2: CountryIso2Code.RO,
    name: 'Romania (România)',
    priority: 0,
    timezone: 'Europe/Bucharest',
  },
  RS: {
    areaCodes: null,
    currency: CurrencyCode.RSD,
    dialCode: '381',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/RS.png',
    iso2: CountryIso2Code.RS,
    name: 'Serbia (Србија)',
    priority: 0,
    timezone: 'Europe/Belgrade',
  },
  RU: {
    areaCodes: null,
    currency: CurrencyCode.RUB,
    dialCode: '7',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/RU.png',
    iso2: CountryIso2Code.RU,
    name: 'Russia (Россия)',
    priority: 0,
    timezone: 'Asia/Krasnoyarsk',
  },
  RW: {
    areaCodes: null,
    currency: CurrencyCode.RWF,
    dialCode: '250',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/RW.png',
    iso2: CountryIso2Code.RW,
    name: 'Rwanda',
    priority: 0,
    timezone: 'Africa/Kigali',
  },
  SA: {
    areaCodes: null,
    currency: CurrencyCode.SAR,
    dialCode: '966',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SA.png',
    iso2: CountryIso2Code.SA,
    name: 'Saudi Arabia (‫المملكة العربية السعودية‬‎)',
    priority: 0,
    timezone: 'Asia/Riyadh',
  },
  SB: {
    areaCodes: null,
    currency: CurrencyCode.SBD,
    dialCode: '677',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SB.png',
    iso2: CountryIso2Code.SB,
    name: 'Solomon Islands',
    priority: 0,
    timezone: 'Pacific/Guadalcanal',
  },
  SC: {
    areaCodes: null,
    currency: CurrencyCode.SCR,
    dialCode: '248',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SC.png',
    iso2: CountryIso2Code.SC,
    name: 'Seychelles',
    priority: 0,
    timezone: 'Indian/Mahe',
  },
  SD: {
    areaCodes: null,
    currency: CurrencyCode.SDG,
    dialCode: '249',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SD.png',
    iso2: CountryIso2Code.SD,
    name: 'Sudan (‫السودان‬‎)',
    priority: 0,
    timezone: 'Africa/Khartoum',
  },
  SE: {
    areaCodes: null,
    currency: CurrencyCode.SEK,
    dialCode: '46',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SE.png',
    iso2: CountryIso2Code.SE,
    name: 'Sweden (Sverige)',
    priority: 0,
    timezone: 'Europe/Stockholm',
  },
  SG: {
    areaCodes: null,
    currency: CurrencyCode.SGD,
    dialCode: '65',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SG.png',
    iso2: CountryIso2Code.SG,
    name: 'Singapore',
    priority: 0,
    timezone: 'Asia/Singapore',
  },
  SH: {
    areaCodes: null,
    currency: CurrencyCode.SHP,
    dialCode: '290',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SH.png',
    iso2: CountryIso2Code.SH,
    name: 'Saint Helena',
    priority: 0,
    timezone: 'Atlantic/St_Helena',
  },
  SI: {
    areaCodes: null,
    currency: CurrencyCode.EUR,
    dialCode: '386',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SI.png',
    iso2: CountryIso2Code.SI,
    name: 'Slovenia (Slovenija)',
    priority: 0,
    timezone: 'Europe/Ljubljana',
  },
  SJ: {
    areaCodes: null,
    currency: CurrencyCode.NOK,
    dialCode: '47',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SJ.png',
    iso2: CountryIso2Code.SJ,
    name: 'Svalbard and Jan Mayen',
    priority: 1,
    timezone: 'Arctic/Longyearbyen',
  },
  SK: {
    areaCodes: null,
    currency: CurrencyCode.EUR,
    dialCode: '421',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SK.png',
    iso2: CountryIso2Code.SK,
    name: 'Slovakia (Slovensko)',
    priority: 0,
    timezone: 'Europe/Bratislava',
  },
  SL: {
    areaCodes: null,
    currency: CurrencyCode.SLL,
    dialCode: '232',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SL.png',
    iso2: CountryIso2Code.SL,
    name: 'Sierra Leone',
    priority: 0,
    timezone: 'Africa/Freetown',
  },
  SM: {
    areaCodes: null,
    currency: CurrencyCode.EUR,
    dialCode: '378',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SM.png',
    iso2: CountryIso2Code.SM,
    name: 'San Marino',
    priority: 0,
    timezone: 'Europe/San_Marino',
  },
  SN: {
    areaCodes: null,
    currency: CurrencyCode.XOF,
    dialCode: '221',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SN.png',
    iso2: CountryIso2Code.SN,
    name: 'Senegal (Sénégal)',
    priority: 0,
    timezone: 'Africa/Dakar',
  },
  SO: {
    areaCodes: null,
    currency: CurrencyCode.SOS,
    dialCode: '252',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SO.png',
    iso2: CountryIso2Code.SO,
    name: 'Somalia (Soomaaliya)',
    priority: 0,
    timezone: 'Africa/Mogadishu',
  },
  SR: {
    areaCodes: null,
    currency: CurrencyCode.SRD,
    dialCode: '597',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SR.png',
    iso2: CountryIso2Code.SR,
    name: 'Suriname',
    priority: 0,
    timezone: 'America/Paramaribo',
  },
  SS: {
    areaCodes: null,
    currency: CurrencyCode.USD,
    dialCode: '211',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SS.png',
    iso2: CountryIso2Code.SS,
    name: 'South Sudan (‫جنوب السودان‬‎)',
    priority: 0,
    timezone: 'Africa/Juba',
  },
  ST: {
    areaCodes: null,
    currency: CurrencyCode.STD,
    dialCode: '239',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ST.png',
    iso2: CountryIso2Code.ST,
    name: 'São Tomé and Príncipe (São Tomé e Príncipe)',
    priority: 0,
    timezone: 'Africa/Sao_Tome',
  },
  SV: {
    areaCodes: null,
    currency: CurrencyCode.USD,
    dialCode: '503',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SV.png',
    iso2: CountryIso2Code.SV,
    name: 'El Salvador',
    priority: 0,
    timezone: 'America/El_Salvador',
  },
  SX: {
    areaCodes: null,
    currency: CurrencyCode.ANG,
    dialCode: '1721',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SX.png',
    iso2: CountryIso2Code.SX,
    name: 'Sint Maarten',
    priority: 0,
    timezone: 'America/Lower_Princes',
  },
  SY: {
    areaCodes: null,
    currency: CurrencyCode.SYP,
    dialCode: '963',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SY.png',
    iso2: CountryIso2Code.SY,
    name: 'Syria (‫سوريا‬‎)',
    priority: 0,
    timezone: 'Asia/Damascus',
  },
  SZ: {
    areaCodes: null,
    currency: CurrencyCode.SZL,
    dialCode: '268',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SZ.png',
    iso2: CountryIso2Code.SZ,
    name: 'Swaziland',
    priority: 0,
    timezone: 'Africa/Mbabane',
  },
  TC: {
    areaCodes: null,
    currency: CurrencyCode.USD,
    dialCode: '1649',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TC.png',
    iso2: CountryIso2Code.TC,
    name: 'Turks and Caicos Islands',
    priority: 0,
    timezone: 'America/Grand_Turk',
  },
  TD: {
    areaCodes: null,
    currency: CurrencyCode.XAF,
    dialCode: '235',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TD.png',
    iso2: CountryIso2Code.TD,
    name: 'Chad (Tchad)',
    priority: 0,
    timezone: 'Africa/Ndjamena',
  },
  TG: {
    areaCodes: null,
    currency: CurrencyCode.XOF,
    dialCode: '228',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TG.png',
    iso2: CountryIso2Code.TG,
    name: 'Togo',
    priority: 0,
    timezone: 'Africa/Lome',
  },
  TH: {
    areaCodes: null,
    currency: CurrencyCode.THB,
    dialCode: '66',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TH.png',
    iso2: CountryIso2Code.TH,
    name: 'Thailand (ไทย)',
    priority: 0,
    timezone: 'Asia/Bangkok',
  },
  TJ: {
    areaCodes: null,
    currency: CurrencyCode.TJS,
    dialCode: '992',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TJ.png',
    iso2: CountryIso2Code.TJ,
    name: 'Tajikistan',
    priority: 0,
    timezone: 'Asia/Dushanbe',
  },
  TK: {
    areaCodes: null,
    currency: CurrencyCode.NZD,
    dialCode: '690',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TK.png',
    iso2: CountryIso2Code.TK,
    name: 'Tokelau',
    priority: 0,
    timezone: 'Pacific/Fakaofo',
  },
  TL: {
    areaCodes: null,
    currency: CurrencyCode.USD,
    dialCode: '670',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TL.png',
    iso2: CountryIso2Code.TL,
    name: 'Timor-Leste',
    priority: 0,
    timezone: 'Asia/Dili',
  },
  TM: {
    areaCodes: null,
    currency: CurrencyCode.TMT,
    dialCode: '993',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TM.png',
    iso2: CountryIso2Code.TM,
    name: 'Turkmenistan',
    priority: 0,
    timezone: 'Asia/Ashgabat',
  },
  TN: {
    areaCodes: null,
    currency: CurrencyCode.TND,
    dialCode: '216',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TN.png',
    iso2: CountryIso2Code.TN,
    name: 'Tunisia (‫تونس‬‎)',
    priority: 0,
    timezone: 'Africa/Tunis',
  },
  TO: {
    areaCodes: null,
    currency: CurrencyCode.TOP,
    dialCode: '676',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TO.png',
    iso2: CountryIso2Code.TO,
    name: 'Tonga',
    priority: 0,
    timezone: 'Pacific/Tongatapu',
  },
  TR: {
    areaCodes: null,
    currency: CurrencyCode.TRY,
    dialCode: '90',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TR.png',
    iso2: CountryIso2Code.TR,
    name: 'Turkey (Türkiye)',
    priority: 0,
    timezone: 'Europe/Istanbul',
  },
  TT: {
    areaCodes: null,
    currency: CurrencyCode.TTD,
    dialCode: '1868',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TT.png',
    iso2: CountryIso2Code.TT,
    name: 'Trinidad and Tobago',
    priority: 0,
    timezone: 'America/Port_of_Spain',
  },
  TV: {
    areaCodes: null,
    currency: CurrencyCode.AUD,
    dialCode: '688',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TV.png',
    iso2: CountryIso2Code.TV,
    name: 'Tuvalu',
    priority: 0,
    timezone: 'Etc/GMT-12',
  },
  TW: {
    areaCodes: null,
    currency: CurrencyCode.TWD,
    dialCode: '886',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TW.png',
    iso2: CountryIso2Code.TW,
    name: 'Taiwan (台灣)',
    priority: 0,
    timezone: 'Asia/Taipei',
  },
  TZ: {
    areaCodes: null,
    currency: CurrencyCode.TZS,
    dialCode: '255',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TZ.png',
    iso2: CountryIso2Code.TZ,
    name: 'Tanzania',
    priority: 0,
    timezone: 'Africa/Dar_es_Salaam',
  },
  UA: {
    areaCodes: null,
    currency: CurrencyCode.UAH,
    dialCode: '380',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/UA.png',
    iso2: CountryIso2Code.UA,
    name: 'Ukraine (Україна)',
    priority: 0,
    timezone: 'Europe/Kiev',
  },
  UG: {
    areaCodes: null,
    currency: CurrencyCode.UGX,
    dialCode: '256',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/UG.png',
    iso2: CountryIso2Code.UG,
    name: 'Uganda',
    priority: 0,
    timezone: 'Africa/Kampala',
  },
  US: {
    areaCodes: null,
    currency: CurrencyCode.USD,
    dialCode: '1',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/US.png',
    iso2: CountryIso2Code.US,
    name: 'United States',
    priority: 0,
    timezone: 'America/Chicago',
  },
  UY: {
    areaCodes: null,
    currency: CurrencyCode.UYU,
    dialCode: '598',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/UY.png',
    iso2: CountryIso2Code.UY,
    name: 'Uruguay',
    priority: 0,
    timezone: 'America/Montevideo',
  },
  UZ: {
    areaCodes: null,
    currency: CurrencyCode.UZS,
    dialCode: '998',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/UZ.png',
    iso2: CountryIso2Code.UZ,
    name: 'Uzbekistan (Oʻzbekiston)',
    priority: 0,
    timezone: 'Asia/Samarkand',
  },
  VA: {
    areaCodes: null,
    currency: CurrencyCode.EUR,
    dialCode: '39',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/VA.png',
    iso2: CountryIso2Code.VA,
    name: 'Vatican City (Città del Vaticano)',
    priority: 1,
    timezone: 'Europe/Rome',
  },
  VC: {
    areaCodes: null,
    currency: CurrencyCode.XCD,
    dialCode: '1784',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/VC.png',
    iso2: CountryIso2Code.VC,
    name: 'Saint Vincent and the Grenadines',
    priority: 0,
    timezone: 'America/St_Vincent',
  },
  VE: {
    areaCodes: null,
    currency: CurrencyCode.VES,
    dialCode: '58',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/VE.png',
    iso2: CountryIso2Code.VE,
    name: 'Venezuela',
    priority: 0,
    timezone: 'America/Caracas',
  },
  VG: {
    areaCodes: null,
    currency: CurrencyCode.USD,
    dialCode: '1284',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/VG.png',
    iso2: CountryIso2Code.VG,
    name: 'British Virgin Islands',
    priority: 0,
    timezone: 'America/Tortola',
  },
  VI: {
    areaCodes: null,
    currency: CurrencyCode.USD,
    dialCode: '1340',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/VI.png',
    iso2: CountryIso2Code.VI,
    name: 'U.S. Virgin Islands',
    priority: 0,
    timezone: 'America/St_Thomas',
  },
  VN: {
    areaCodes: null,
    currency: CurrencyCode.VND,
    dialCode: '84',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/VN.png',
    iso2: CountryIso2Code.VN,
    name: 'Vietnam (Việt Nam)',
    priority: 0,
    timezone: 'Asia/Ho_Chi_Minh',
  },
  VU: {
    areaCodes: null,
    currency: CurrencyCode.VUV,
    dialCode: '678',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/VU.png',
    iso2: CountryIso2Code.VU,
    name: 'Vanuatu',
    priority: 0,
    timezone: 'Pacific/Efate',
  },
  WF: {
    areaCodes: null,
    currency: CurrencyCode.XPF,
    dialCode: '681',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/WF.png',
    iso2: CountryIso2Code.WF,
    name: 'Wallis and Futuna (Wallis-et-Futuna)',
    priority: 0,
    timezone: 'Pacific/Wallis',
  },
  WS: {
    areaCodes: null,
    currency: CurrencyCode.WST,
    dialCode: '685',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/WS.png',
    iso2: CountryIso2Code.WS,
    name: 'Samoa',
    priority: 0,
    timezone: 'Pacific/Apia',
  },
  XK: {
    areaCodes: null,
    currency: CurrencyCode.EUR,
    dialCode: '383',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/XK.png',
    iso2: CountryIso2Code.XK,
    name: 'Kosovo',
    priority: 0,
    timezone: 'Europe/Rome',
  },
  YE: {
    areaCodes: null,
    currency: CurrencyCode.YER,
    dialCode: '967',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/YE.png',
    iso2: CountryIso2Code.YE,
    name: 'Yemen (‫اليمن‬‎)',
    priority: 0,
    timezone: 'Asia/Aden',
  },
  YT: {
    areaCodes: null,
    currency: CurrencyCode.EUR,
    dialCode: '262',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/YT.png',
    iso2: CountryIso2Code.YT,
    name: 'Mayotte',
    priority: 1,
    timezone: 'Indian/Mayotte',
  },
  ZA: {
    areaCodes: null,
    currency: CurrencyCode.ZAR,
    dialCode: '27',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ZA.png',
    iso2: CountryIso2Code.ZA,
    name: 'South Africa',
    priority: 0,
    timezone: 'Africa/Johannesburg',
  },
  ZM: {
    areaCodes: null,
    currency: CurrencyCode.ZMK,
    dialCode: '260',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ZM.png',
    iso2: CountryIso2Code.ZM,
    name: 'Zambia',
    priority: 0,
    timezone: 'Africa/Lusaka',
  },
  ZW: {
    areaCodes: null,
    currency: CurrencyCode.ZWL,
    dialCode: '263',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ZW.png',
    iso2: CountryIso2Code.ZW,
    name: 'Zimbabwe',
    priority: 0,
    timezone: 'Africa/Harare',
  },
}
